module.exports = __webpack_public_path__ + "img/f5.3afb3fe7.png";